import { createSelector } from "reselect"
import { get, orderBy } from "lodash"

const EMPTY_ARRAY = []
const getFilters = state => get(state, "global.data.filters.data")
const getChips = (state, props) => get(props, "chips", EMPTY_ARRAY)

export const getCurrentFilter = state => get(state, "modules.filterSaver.currentFilter")
export const getCurrentFilterName = state => get(state, "modules.filterSaver.currentFilterName")
export const getCurrentFilterId = state => get(state, "modules.filterSaver.currentFilterId")

export const getFiltersCount = createSelector(
  [getChips],
  (chips) => {
    return chips.length
  },
)

export const getSortedSavedSearches = createSelector(
  [getFilters],
  (filters) => orderBy(filters, ["updatedAt"], ["desc"]),
)

export const getResultsCount = state => get(state, "global.data.searchFacets.data.model.securitySearch.count")
